import { createSlice } from '@reduxjs/toolkit'
import {getExceptionLevels, getExceptions} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState= { 
  exceptions: {
    pageIndex: 0,
    totalRecords: 10,
    totalPages: 1,
    pageSize: 15,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: []
  },
  exceptionLevels:[], 
  loading: "idle",
  loadingLevels: "idle",
  error: null }

const exceptionsSlice = createSlice({
  name: 'exceptions',
  initialState,
  reducers: {
    clearExceptionsError: (state)=>{
      state.error = null
      state.loading = "idle"
    }
  },
  extraReducers: {
    [getExceptions.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [getExceptions.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.exceptions = action.payload
    state.exceptions.pageIndex = action.payload.pageIndex;
    state.exceptions.totalRecords = action.payload.totalRecords;
    state.exceptions.totalPages = action.payload.totalPages;
    state.exceptions.pageSize = action.payload.pageSize;
    state.exceptions.hasPreviousPage = action.payload.hasPreviousPage;
    state.exceptions.hasNextPage = action.payload.hasNextPage
      
    },
    [getExceptions.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
      },
    [getExceptionLevels.pending]:(state)=>
      {
        state.loadingLevels = "loading"
      },
    [getExceptionLevels.fulfilled]:(state, action)=>
        {
          state.exceptionLevels = action.payload;
          state.loadingLevels = "succeeded"
        }
    ,
    [getExceptionLevels.rejected]: (state, action) => {
      state.loadingLevels = "failed"; 
      state.error = action.error.message
    },
    [logOut]: (state)=> initialState
  }
})

export const {clearExceptionsError} = exceptionsSlice.actions;
export default exceptionsSlice.reducer
